/**
 * Client-side permission migration.
 *
 * Bridges the gap between newly-added pages (registered in pages.json) and the
 * permissions actually stored against existing roles in the backend. Without this
 * layer, every new page would require an admin to manually edit every role and
 * every user to re-login before the sidebar entry appears — even when the new
 * page is the obvious successor of a permission the role already has.
 *
 * Pattern mirrors arise-admin's permission-migration.ts.
 */
export function migratePermissions(permissions: any): any {
  if (!permissions || typeof permissions !== 'object') return permissions;

  const migrated = { ...permissions };

  // Auto-grant "Test Upload" to roles that already have content-creation access.
  // The AI-assisted test-upload feature is the natural successor of the manual
  // test-creation flow — anyone who can build a Test or work in the Question
  // Bank should be able to use it without a manual role-edit + re-login cycle.
  // Roles that explicitly should NOT see Test Upload can be edited in the role
  // UI to drop it — this migration only ADDS when missing.
  if (
    !migrated['Test Upload'] &&
    (migrated['Test'] || migrated['Question Bank'] || migrated['Admin Panel'])
  ) {
    migrated['Test Upload'] = ['Upload Test', 'Review & Approve'];
  }

  return migrated;
}

/**
 * Get migrated permissions from localStorage.
 * Use this in components instead of reading localStorage directly.
 */
export function getMigratedPermissions(): any {
  try {
    const permissions = JSON.parse(localStorage.getItem('permissions') || '{}');
    return migratePermissions(permissions);
  } catch (e) {
    return {};
  }
}
